<template v-if="editValueRestrictionMenu.isVisible">
    <div>
        <SwipeModalComponent @closeMenu="changeEditValueRestrictionMenuVisibility" v-if="editValueRestrictionMenu.isVisible">
            <div class="content-wrapper">
                <h2 v-text="schoolName"></h2>

                <div class="daily-limit">
                    <text>Limite diário</text>
                    <input type="text" placeholder="R$ 0,00" maxlength="12" v-model="formattedLimit" @input="formatValue" />
                </div>

                <div class="buttons" >
                    <button @click="openDelModal" class="delete fa fa-trash fa-2xl"></button>
                    <button @click="updateLimit" class="confirm">Confirmar</button>
                </div>
            </div>
        </SwipeModalComponent>
        <ModalInfo :modalOpen="confirmModalOpen" @actionTrue="deleteRestriction" @actionFalse="closeModal" />
    </div>
</template>
<script >
import SwipeModalComponent from './SwipeModalComponent.vue'
import ModalInfo from '../modals/ModalInfo.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'EditValueRestrictionComponent',
    props: ['schoolName', 'schoolLimit'],
    emits: ['updateLimit', 'deleteRestriction'],
    components: {
        SwipeModalComponent,
        ModalInfo
    },
    data () {
        return {
            limit: 0,
            formattedLimit: 'R$ 0,00',
            confirmModalOpen: false
        }
    },
    computed: {
        ...mapGetters(['editValueRestrictionMenu'])
    },
    methods: {
        ...mapActions(['changeEditValueRestrictionMenuVisibility', 'showModalInfo']),
        updateLimit: function () {
            this.changeEditValueRestrictionMenuVisibility()
            this.$emit('updateLimit', this.limit)
        },
        deleteRestriction: function () {
            this.changeEditValueRestrictionMenuVisibility()
            this.closeModal()
            this.$emit('deleteRestriction')
        },
        formatValue (event) {
            const value = event.target.value.replace(/\D/g, '')
            const formattedValue = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value / 100)
            this.formattedLimit = formattedValue
            this.limit = value / 100
        },
        openDelModal () {
            this.confirmModalOpen = true
            this.showModalInfo({
                type: 'defaultDialog',
                text: 'Deseja deletar a restrição? Caso hajam produtos restritos, a restrição será atualizada para R$ 0,00.',
                icon: 'fa-solid fa-circle-question'
            })
        },
        closeModal () {
            this.confirmModalOpen = false
        }
    },
    watch: {
        schoolLimit (val) {
            this.limit = val
            this.formattedLimit = val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        }
    }
}
</script>

<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;

    .stripe {
        position: relative;
        display: block;
        width: 35px;
        height: 4px;
        background: #B4B4B4;
        border-radius: 30px;
        margin: 30px auto 25px auto;
    }

    h2 {
        text-align: center;

        &:last-of-type {
            margin-bottom: 40px;
        }
    }

    .daily-limit {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 40px;

        input {
            width: 40%;
            border: 1px solid #B4B4B4;
            border-radius: 5px;
            padding: 10px 0;
            text-align: center;
            margin-top: 10px;
        }
    }

    .buttons {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        margin-top: 20px;

        .confirm {
          color: var(--buttonText);
          background-color: var(--buttonBackground);
        }
    }

    button {
        color: var(--iconColor);
        border-radius: 5px;
        padding: 10px;
        margin: 0;
        border: none;
        background-color: transparent;
    }
}
</style>
